<script>
import { mapMutations } from "vuex";
import { forEach } from "lodash";
import axios from "axios";

export default {
  name: "WorkflowButtons",
  props: {
    state: { default: "" },
    onsave: { type: Function, default: null },
    loadedButtons: { type: Array, default: () => [] },
  },
  methods: {
    ...mapMutations(["showMessage"]),
    handleClick(index) {
      const vm = this;
      if (this.onsave) {
        this.onsave(function () {
          var data = {
            state_id: vm.state,
            actionName: vm.buttons[index].actions,
          };
          axios
            .post("/forms247/v1/execute/", data)
            .then((response) => {
              vm.$emit("close", response.data);
            })
            .catch((error) => {
              vm.showMessage({
                message: "An error occurred:" + error.response.data.error,
                type: "danger",
                show: true,
              });
            });
        });
      }
    },
  },
  computed: {
    buttons() {
      var result = [];
      forEach(this.loadedButtons, function (btn) {
        result.push({
          label: btn.name,
          variant: btn.variant || "primary",
          actions: btn.actions,
        });
      });
      return result;
    },
  },
};
</script>

<template>
  <div
    class="btn-group mb-0 ml-3 align-items-center"
    role="group"
    aria-label="Workflow buttons"
  >
    <button
      v-for="(button, index) in buttons"
      :key="index"
      type="button"
      :class="['btn', `btn-${button.variant}`]"
      @click="handleClick(index)"
    >
      {{ button.label }}
    </button>
  </div>
</template>

<style scoped></style>
